module.exports = __webpack_public_path__ + "static/media/volontar_logo_white.324aea30.svg";